import { render, staticRenderFns } from "./chengYuan.vue?vue&type=template&id=0a63b1ee&scoped=true"
import script from "./chengYuan.vue?vue&type=script&lang=js"
export * from "./chengYuan.vue?vue&type=script&lang=js"
import style0 from "./chengYuan.vue?vue&type=style&index=0&id=0a63b1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63b1ee",
  null
  
)

export default component.exports